import { Loader } from '../Loader';
import * as DOM from './DOM';
import { TrueType } from './enums/TrueType';
import * as String from './String';
import * as Type from './Type';
import * as URL from './URL';
export const preloadImages = (urls, callback) => {
    let loadedCounter = 0;
    const toBeLoadedNumber = urls.length;
    const output = {
        loaded: [],
        failed: []
    };
    const preloadImage = (url, anImageLoadedCallback, failedImageLoadCallback) => {
        const img = new Image();
        img.src = url;
        img.onload = anImageLoadedCallback;
        img.onerror = failedImageLoadCallback;
    };
    urls.forEach((url) => {
        preloadImage(url, (event) => {
            loadedCounter++;
            output.loaded.push(event.target.src);
            if (loadedCounter === toBeLoadedNumber && callback !== undefined)
                callback(output);
        }, (event) => {
            loadedCounter++;
            output.failed.push(event.target.src);
            if (loadedCounter === toBeLoadedNumber && callback !== undefined)
                callback(output);
        });
    });
};
export const code = (url, parentElement = document.head, async = false, prepend = false, onLoadComplete = undefined, onLoadFailure = undefined, attributes = undefined) => {
    if (alreadyPresent(url) === true) {
        if (onLoadComplete !== undefined)
            onLoadComplete({ target: url, url: url });
        return;
    }
    const pattern = /\.([0-9a-z]+)(?:[\?#]|$)/i;
    const type = (url).match(pattern)[1];
    let scriptElement;
    const referenceElement = null;
    switch (type) {
        case 'css':
            scriptElement = document.createElement('link');
            scriptElement.rel = 'stylesheet';
            scriptElement.type = 'text/css';
            scriptElement.media = 'screen';
            scriptElement.href = url;
            break;
        case 'js':
            scriptElement = document.createElement('script');
            scriptElement.type = 'text/javascript';
            scriptElement.src = url;
            if (async === true)
                scriptElement.async = async;
            break;
    }
    if (Type.isDefined(attributes) && Type.isObject(attributes)) {
        Object.keys(attributes).forEach((key) => {
            scriptElement.setAttribute(key, attributes[key]);
        });
    }
    scriptElement.onload = (event) => {
        if (Type.isFunction(onLoadComplete))
            onLoadComplete(event);
    };
    scriptElement.onerror = (event) => {
        if (Type.isFunction(onLoadFailure)) {
            onLoadFailure(event);
        }
        else {
            if (Type.isFunction(onLoadComplete))
                onLoadComplete(event);
        }
    };
    prepend !== true ? parentElement.appendChild(scriptElement) : parentElement.insertBefore(scriptElement, referenceElement);
};
export const removeCode = (url, id = undefined, callback = undefined, param = undefined) => {
    if (alreadyPresent(url) === false) {
        return;
    }
    if (id !== undefined) {
        document.getElementById(id).parentNode.removeChild(document.getElementById(id));
        if (callback !== undefined)
            callback(param);
        return;
    }
    const type = url.split('.')[url.split('.').length - 1];
    const targetElement = (type === 'js') ? 'script' : (type === 'css') ? 'link' : 'none';
    const targetAttribute = (type === 'js') ? 'src' : (type === 'css') ? 'href' : 'none';
    const allSuspects = document.getElementsByTagName(targetElement);
    for (let i = allSuspects.length; i >= 0; i--) {
        if (allSuspects[i] && allSuspects[i].getAttribute(targetAttribute) !== null && allSuspects[i].getAttribute(targetAttribute).indexOf(url) !== -1) {
            allSuspects[i].parentNode.removeChild(allSuspects[i]);
        }
    }
    if (callback !== undefined)
        callback(param);
};
export const alreadyPresent = (url, namespace = undefined, urlCheck = true) => {
    const cleanURL = url.split('?')[0].replace(/^https?\:\/\//i, '');
    const params = url.indexOf('?') > -1 ? url.split('?')[1] : '';
    const pattern = /\.([0-9a-z]+)(?:[\?#]|$)/i;
    let type = (url).match(pattern)[1];
    if (type === 'css')
        type = 'link';
    if (type === 'js')
        type = 'script';
    const elements = document.getElementsByTagName(type);
    const namespaceExists = (ns) => {
        switch (Type.isString(ns)) {
            case false:
                return true;
            case true:
                return !Type.isNull(DOM.getDeepVal(window, ns));
        }
    };
    for (let i = 0; i < elements.length; i++) {
        const srcURL = elements[i][(type === 'script' ? 'src' : 'href')].split('?')[0].replace(/^https?\:\/\//i, '');
        switch (type) {
            case 'link':
                switch (urlCheck) {
                    case false:
                        return false;
                        break;
                    case true:
                        if (srcURL === cleanURL)
                            return true;
                        break;
                }
                break;
            case 'script':
                switch (urlCheck) {
                    case false:
                        return namespaceExists(namespace);
                        break;
                    case true:
                        if (srcURL === cleanURL) {
                            return namespaceExists(namespace);
                        }
                        break;
                }
                break;
        }
    }
    return false;
};
export const loader = Loader;
export const getFileURL = (tag = '', pathPatterns = [], domain = undefined) => {
    const tags = document.getElementsByTagName(tag);
    for (let i = 0; i < tags.length; i++) {
        const url = tags[i].src;
        const parsed = URL.parser(url);
        if (String.hasSubstring(parsed.pathname, pathPatterns)) {
            if (Type.isString(domain)) {
                if (parsed.host.indexOf(domain) > -1)
                    return url;
            }
            return url;
        }
    }
    return undefined;
};
export const xhrLoad = (url, callbackObj, successCallback, failureCallback, timeout = 10000) => {
    let xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    const xhrTimer = setTimeout(() => {
        xhr.abort();
        xhr = null;
        const errStr = 'Service call timeout';
        failureCallback.call(callbackObj, errStr);
    }, timeout);
    xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
            clearTimeout(xhrTimer);
            if (xhr.status === 200) {
                successCallback.call(callbackObj, xhr);
            }
            else {
                const errStr = 'xhrLoad load status != 200 xhr.status = ' + xhr.status;
                failureCallback.call(callbackObj, errStr);
                xhr = null;
            }
        }
    };
    xhr.send(null);
};
export const WebWorker = () => {
    const createURL = (func_or_string) => {
        const str = (typeof func_or_string === TrueType.FUNCTION) ? func_or_string.toString() : func_or_string;
        const blob = new Blob(['self.onmessage =' + str], { type: 'text/javascript' });
        return window.URL.createObjectURL(blob);
    };
    const create = (func_or_string) => {
        return new Worker(createURL(func_or_string));
    };
    return {
        createURL: createURL,
        create: create
    };
};
